
import { TimePart } from "src/app/view-models/utilities/time-part";
import { StoredTimePart } from "../models/stored-utilities/stored-time-part";
import { IStoredMapper } from "./stored-mapper";

/**
 * Mapping class that maps between TimePart view model and database StoredTimePart.
 */
export class TimePartMapper implements IStoredMapper<TimePart, StoredTimePart> {
	/**
	 * Maps a TimePart to a StoredTimePart.
	 * @param timePart The time part data to convert.
	 * @returns A StoredTimePart object.
	 */
	public ToStored(timePart: TimePart): StoredTimePart {
		return {
			Hours: timePart.Hours,
			Minutes: timePart.Minutes,
			Seconds: timePart.Seconds,
		};
	}

	/**
	 * Maps a StoredTimePart to a TimePart.
	 * @param storedTimePart The stored time part data to convert.
	 * @returns A TimePart object.
	 */
	public FromStored(storedTimePart: StoredTimePart): TimePart {
		const zeroPad = (num: number) => String(num).padStart(2, '0');
		const timeString = `${zeroPad(storedTimePart.Hours)}:${zeroPad(storedTimePart.Minutes)}:${zeroPad(storedTimePart.Seconds)}` ;

		return new TimePart(timeString);
	}
}